import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getCampaignWidgetStyles } from './CampaignWidgetStyles';
import { StatusCardWidget } from '../status-card-widget';
import { GridCol, GridRow, Typography } from '@airtel/air-design-system';
export var CampaignWidgetComponent = props => {
  var campaignList = props.campaignList,
    campaignTitleBreakpoints = props.campaignTitleBreakpoints,
    campaignTitle = props.campaignTitle;
  var campaignWidgetStyles = getCampaignWidgetStyles();
  return _jsxs(GridRow, {
    children: [!!campaignTitle && _jsx(GridCol, Object.assign({
      style: campaignWidgetStyles.gridTitleCol,
      breakpoints: campaignTitleBreakpoints
    }, {
      children: _jsx(Typography, {
        type: "h4-bold",
        text: campaignTitle
      })
    })), campaignList === null || campaignList === void 0 ? void 0 : campaignList.map((campaign, index) => _jsx(GridCol, Object.assign({
      breakpoints: campaign === null || campaign === void 0 ? void 0 : campaign.breakpoints
    }, {
      children: _jsx(StatusCardWidget, Object.assign({}, campaign))
    }), "campaign_list_" + index))]
  });
};
CampaignWidgetComponent.genericRendererKey = 'AirCampaignWidget';